import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountCharacterPage } from './account-character.page';
import { PagesModule } from '../../pages.module';


const routes: Routes = [
  {
    path: '',
    component: AccountCharacterPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AccountCharacterPage]
})
export class AccountCharacterPageModule { }
